import { styled, Typography } from "@mui/material";
import { CarVirtualTable } from "@app/components/VirtualTable";
import { memo } from "react";
import { formatNumber, formatPercentFactor, isDefined } from "@app/utils";
import { CarSimAnalyzePathTable } from "./SimulationXrayDialog";
import { FieldTypeEnum } from "@app/api/carApi.generated";
import { pendoClasses } from "@app/core/thirdParty/pendo";
import { CarTooltipBox } from "@app/components/TooltipBox";

interface SimulationXrayTableProps {
  className?: string;
  table: CarSimAnalyzePathTable;
}

const formatValue = (value?: number | null, type?: FieldTypeEnum) => {
  if (!isDefined(value)) {
    return "-";
  }

  switch (type) {
    case "percentage":
      return formatPercentFactor(value, {
        decimalPlaces: 2,
        forceShowDecimals: true,
      });
    case "boolean":
      return value ? "true" : "false";
    default:
      return formatNumber(value, {
        decimalPlaces: 2,
        forceShowDecimals: true,
      });
  }
};

const Table = memo(({ className, table }: SimulationXrayTableProps) => {
  return (
    <CarVirtualTable
      className={className}
      columnCount={table.columns.length}
      rowWidth={80}
      rowCount={table.rows.length}
      rowHeaderWidth={200}
      onRenderColumnRowHeader={() => (
        <Typography
          sx={{ ml: 1, alignSelf: "flex-start" }}
          variant="h6SSemiBold"
        >
          Paths
        </Typography>
      )}
      sxColumnHeader={() => ({
        cursor: "pointer",
        userSelect: "none",
      })}
      onRenderColumnHeader={(col) => (
        <Typography variant="par02Regular">
          {table.columns.at(col)?.year}
        </Typography>
      )}
      onRenderRowHeader={(rowIndex) => {
        const row = table.rows.at(rowIndex);
        if (!row) {
          return null;
        }
        return (
          <Typography
            variant="par02Regular"
            sx={{ ml: 1, alignSelf: "flex-start" }}
          >
            {row.label}
            <CarTooltipBox
              sx={{ display: "inline-block", ml: 0.5, mb: -0.5 }}
              className={pendoClasses.simulationFieldYAxis(row.code)}
            />
          </Typography>
        );
      }}
      onRenderCell={(col, row) =>
        formatValue(
          table.rows.at(row)?.values.at(col),
          table.rows.at(row)?.fieldType,
        )
      }
    />
  );
});

export const SimulationXrayTable = styled(Table)(() => ({}));
